import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';

import styles from './style.module.less';

interface WheelProps {
  value: any;
  delay: number;
  duration?: number;
  loading?: boolean;
  height?: number;
  width?: number | string;
  className: string;
}

const Wheel: React.FC<WheelProps> = ({
  className,
  value,
  delay,
  duration = 200,
  height = 50,
  width = 50,
  loading = false
}) => {
  const wheelRef = useRef<HTMLDivElement>(null);

  const setWheelPosition = (digit: number, animate: boolean, duration: number) => {
    const newOffset = -height * digit;
    if (wheelRef.current) {
      wheelRef.current.style.transition = animate ? `transform ${duration}ms ease-in-out` : 'none';
      wheelRef.current.style.transform = `translateY(${newOffset - height / 2}px)`;
    }
  };

  const scrollToValue = (targetDigit: number, duration) => {
    setWheelPosition(targetDigit, true, duration);
    setTimeout(() => {
      setWheelPosition(targetDigit - 10, false, duration);
    }, duration);
  };

  useEffect(() => {
    if (loading) {
      wheelRef?.current?.classList.add(styles.spin);
      return;
    }
    if (wheelRef?.current?.classList.contains(styles.spin)) {
      setTimeout(() => {
        wheelRef.current?.classList.remove(styles.spin);
        scrollToValue(value % 10, duration);
      }, delay * 10);
      return;
    }
    setTimeout(() => {
      scrollToValue(value % 10, duration);
    }, delay);
  }, [value, delay, duration, loading]);

  useEffect(() => {
    if (value === '?') return;
    setWheelPosition(value % 10, false, duration); // 初始化时无动画
  }, []);

  return (
    <div className={styles['wheel-container']} style={{ height, width, lineHeight: `${height}px` }}>
      <div className={classNames(styles.wheel)} ref={wheelRef}>
        {value == '?' || value === '.' ? (
          <div className={classNames(styles.digit, className)} style={{ height }}>
            {value}
          </div>
        ) : null}
        {Array.from({ length: 20 }, (_, i) => (
          <div className={classNames(styles.digit, className)} style={{ height }} key={i}>
            {i % 10}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Wheel;
